import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { useDeleteWikiContactMutation, useDeleteWikiLinkMutation } from '../../../redux/rtkQuery/apiWikiSlice';
import { RootState } from '../../../redux/root';
import TableArea, { RecordRow } from './TableArea';
import { setSelectedContact, setSelectedJurisdiction, setSelectedLink } from '../../../redux/slices/wikiSlice';
import AddContactForm from './AddContactForm';
import AddLinkForm from './AddLinkForm';

const TableAreaCollection = () => {
  const [deleteWikiContact] = useDeleteWikiContactMutation();
  const [deleteWikiLinkMutation] = useDeleteWikiLinkMutation();
  const [showAddContact, setShowAddContact] = useState<boolean>(false);
  const [showAddLink, setShowAddLink] = useState<boolean>(false);
  const [contactRows, setContactRows] = useState<RecordRow[]>([]);
  const [linksRows, setLinksRows] = useState<RecordRow[]>([]);
  const juri = useSelector((s: RootState) => s.wikiSlice.selectedJurisdiction);
  const dispatch = useDispatch();

  useEffect(() => {
    if (juri && juri.contacts) {
      const _contacts = juri.contacts.map(c => ({
        id: c.id,
        field1: c.contactName,
        field2: c.contactType,
      }));
      setContactRows(_contacts);
    }

    if (juri && juri.links) {
      const _links = juri.links.map(c => ({
        id: c.id,
        field2: c.link,
        field1: c.description,
      }));
      setLinksRows(_links);
    }
  }, [juri]);

  const editLink = id => {
    const _link = juri.links.find(c => c.id === id);
    dispatch(setSelectedLink(_link));
    setShowAddLink(true);
  };

  const deleteContact = async id => {
    await deleteWikiContact({ id });
    const _juri = {
      ...juri,
      contacts: juri.contacts.reduce((contactArr, contact) => {
        if (contact.id !== id) {
          contactArr.push(contact);
        }
        return contactArr;
      }, []),
    };
    dispatch(setSelectedJurisdiction(_juri));
  };

  const editContact = id => {
    const _contact = juri.contacts.find(c => c.id === id);
    dispatch(setSelectedContact(_contact));
    setShowAddContact(true);
  };

  const deleteLink = async id => {
    await deleteWikiLinkMutation({ id });
    const _juri = {
      ...juri,
      links: juri.links.reduce((linkArr, link) => {
        if (link.id !== id) {
          linkArr.push(link);
        }
        return linkArr;
      }, []),
    };
    dispatch(setSelectedJurisdiction(_juri));
  };
  return (
    <Tables>
      <TableArea
        onEdit={editContact}
        onDelete={deleteContact}
        show={showAddContact}
        setShow={setShowAddContact}
        subject="Contact"
        rows={contactRows}
        headers={['Contact Name', 'Contact Type']}
      >
        <AddContactForm setShow={setShowAddContact} />
      </TableArea>
      <TableArea
        onEdit={editLink}
        onDelete={deleteLink}
        show={showAddLink}
        setShow={setShowAddLink}
        subject="Link"
        rows={linksRows}
        headers={['Link Description', 'Link']}
      >
        <AddLinkForm setShow={setShowAddLink} />
      </TableArea>
    </Tables>
  );
};

export default TableAreaCollection;

const Tables = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  box-sizing: border-box;

  > * {
    flex: 1 1 340px;
    min-width: 0;
  }
`;
